import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { productShortName } from '../data/offer';
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const show = window.setTimeout(() => setVisible(true), 5000);
    const hide = window.setTimeout(() => setVisible(false), 15000);
    return () => {
      window.clearTimeout(show);
      window.clearTimeout(hide);
    };
  }, []);
  return <AnimatePresence data-id="element-212" data-mp="21ydbohrq2ixm">
      {visible && <motion.aside initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 14
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-4 right-4 z-50 w-[calc(100%-2rem)] max-w-sm rounded-lg border border-silver-400/40 border-l-4 border-l-silver-300 bg-navy-800 p-4 pr-10 text-silver-100 shadow-xl shadow-black/40" aria-live="polite" data-id="element-213" data-mp="1wxxvlig22xby">
          <button type="button" onClick={() => setVisible(false)} className="absolute right-2 top-2 rounded p-1 text-silver-300 transition-colors duration-150 ease-out hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-silver-300" aria-label="Cerrar aviso" data-id="element-214" data-mp="1se39jbae402w">
            <XIcon className="h-4 w-4" data-id="element-215" data-mp="19p4z12urxply" />
          </button>
          <div className="flex gap-3" data-id="element-216" data-mp="19nlhza1anaj4">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-silver-200" aria-hidden="true" data-id="element-217" data-mp="1egembwsuoguo" />
            <div data-id="element-218" data-mp="zsa3mstss5bw">
              <p className="text-[10px] font-extrabold uppercase tracking-[.16em] text-silver-300" data-id="element-219" data-mp="zstmqcv6ozri">Acceso confirmado</p>
              <p className="mt-1 text-sm leading-snug" data-id="element-220" data-mp="14o8xux1t4hk8">
                Al completar tu compra recibes el
                <br data-id="element-221" data-mp="qsnaeub825tx" />
                <span className="font-bold text-white" data-id="element-222" data-mp="vpdstoai1dii">{productShortName}</span>
              </p>
              <p className="mt-2 text-xs text-silver-300" data-id="element-223" data-mp="2xejb5e7tul1c">Acceso digital inmediato por correo electrónico</p>
            </div>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}